<template>
  <div>
    
    <h4>{{ cuota.concept }}</h4><br>   
    <span>Total cargo: {{ $currency.format(cuota.totaltc) }}</span><br>   
    
    <span>Tasa: {{ tasa }}%</span><br>
    
    <span>Comisión variable: {{ $currency.format(variable) }}</span><br>
    <span>Comisión fija: {{ $currency.format(fijo) }}</span><br>
    <span>Subtotal comisión: {{ $currency.format(comision) }}</span><br>

    <span>Iva comision: {{ $currency.format(iva_comision) }}</span><br>
    <span>Monto pago: {{ $currency.format(cuota.amount) }}</span><br>
    
   
    <form id="payment-form" @submit.prevent="handleSubmit">
      <div id="payment-element"><!-- Stripe renderiza aquí la tarjeta --></div>
       <v-btn block color="primary" large rounded @click="handleSubmit" class="mt-5"
      >Pagar</v-btn>
      <br>
      <v-btn block color="primary" large outlined rounded to="/maintenancefees" >Cancelar</v-btn>  
    </form>
    <div id="message">{{ message }}</div>
  </div>
</template>

<script>
import { loadStripe } from "@stripe/stripe-js";
import stripeService from '@/services/users/stripe';
import configService from '@/services/admin/config';

export default {
    props: {
        cuota: {
            type: Object,
            required: true,      
        }
  },
  data() {
    return {
      stripe: null,
      paymentIntentId: null,
      clientSecret: null,
      elements: null,
      message: "",
      comision: 0,
      iva_comision: 0,
      tasa: 0,
      total:0,
      fijo: 300, // 3 pesos de interes fijo
      variable:0,
      neto:0,
    };
  },
  async mounted(){

    const stripeSecret = process.env.VUE_APP_STRIPE_SECRET;
    this.stripe = await loadStripe(stripeSecret);
    console.log(stripeSecret);

    this.tasa = await configService.getComisionTarjeta()
      .then(res => {
        return res.data.comisionPagoTarjeta;
      });


    this.total = ( (this.cuota.amount + ( 3 * 1.16 ) ) / (1 - ( ((this.tasa ) / 100) * 1.16 )) ) ;
    this.variable = this.total * (this.tasa / 100 );
    this.comision = this.variable + this.fijo;
    this.iva_comision = ( this.comision * .16 );
    this.cuota.tasa = this.tasa;
    this.cuota.comision = this.comision + this.iva_comision;
    this.neto = this.cuota.amount + this.comision + this.iva_comision;
    this.neto2 = this.neto /100;
    this.cuota.totaltc = Math.ceil(this.neto2) * 100;
    console.log(this.total);
    console.log(this.cuota.totaltc);
   
    stripeService.createPymtIntent(this.cuota)
      .then( res => {
       
        const { clientSecret, paymentIntentId } = res.data; 
        this.clientSecret = clientSecret;           
        this.paymentIntentId = paymentIntentId; 

        this.elements = this.stripe.elements({ clientSecret });
        const paymentElement = this.elements.create('payment', {
          layout: { type: 'tabs' }, // opcional: solo layout de tarjeta
          defaultValues: {},
        });
        paymentElement.mount("#payment-element");
      }).catch((error) => {
            console.log(error);
            if (error.response && [400, 404, 409].includes(error.response.status)) {
              console.log(error);
              this.$swal('Error al cargar Stripe', error.response.data.message, 'warning');
            }
          });
  },
  methods: {
    async handleSubmit() {
      if (!this.stripe || !this.elements) {
        this.message = "Stripe aún no está cargado.";
        return;
      }

      this.message = "Procesando pago...";
      const baseUrl = process.env.VUE_APP_BASE_URL; 
      const url = `${baseUrl}/stripe-succeeded?paymentId=${this.cuota.id}`;
      console.log(url);

      try {
        // Confirmación usando PaymentElement
        const { error, paymentIntent } = await this.stripe.confirmPayment({
          elements: this.elements,
          confirmParams: {
            return_url: `${baseUrl}/stripe-succeeded?paymentId=${this.cuota.id}`, // redireccion
          },
        });

        if (error) {
          this.message = `Error al procesar el pago: ${error.message}`;
          console.log(error);
          return;
        }

        // PaymentIntent completo disponible solo si no hay redirección
        if (paymentIntent) {
          console.log("PaymentIntent:", paymentIntent);
          this.message = `Estado del pago: ${paymentIntent.status}`;
        } else {
          this.message = "Pago enviado, redireccionando...";
        }
      } catch (err) {
        console.error("Error handleSubmit:", err);
        this.message = "Ocurrió un error al procesar el pago.";
      }
    },
    round2(num) {
      return Math.round((num + Number.EPSILON) * 100) / 100;
    }

  },
};
</script>
